<!-- <div class="container-fluid">
  <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="card">
            <div class="card-body">
                <p>OTHER PAYMENTS</p>
                <table>
                  <tr>
                      <th>S/N</th> <th>SERVICE AND PRODUCT DESCRIPTION</th> <th>AMOUNT(N)</th>
                  </tr>
                  <tr >
                    <td>1.</td><td><mat-form-field><input matInput type="text"></mat-form-field></td><td><mat-form-field><input matInput type="text"></mat-form-field></td>
                  </tr>
                
                </table>
              
                <button mat-raised-button style="background-color:#970F0F;color:#fff">Proceed to Payment Page</button>
                <div fxFlex="40"><br /><br />
                  <img src="assets/images/interswitch.png" id="interswitch" />
                  </div>
              </div>
          </div>
    </div>
  </div>
</div> -->
<div class="container-fluid">
    <img src="assets/images/coming.png" class="mx-auto d-block" style="margin-top:10%" />
</div>

